import type { OpenPositionLiveMetrics } from "@/vybe-trader-client/opened-trades/stores/useOpenPositionsLiveMetricsStore";
import { useOpenPositionsLiveMetricsStore } from "@/vybe-trader-client/opened-trades/stores/useOpenPositionsLiveMetricsStore";
import type { OpenPositionTableRowData } from "./types";

export const LIVE_TABLE_COLUMNS = new Set([
  "liveProfit",
  "priceChange",
  "liveCurrentPrice",
]);

export function getLiveMetrics(
  ticket: number
): OpenPositionLiveMetrics | undefined {
  return useOpenPositionsLiveMetricsStore.getState().byTicket.get(ticket);
}

export function getRowSortValue(
  row: OpenPositionTableRowData,
  column: string
): string | number {
  if (column === "tradeType") return row.tradeType;
  if (column === "liveProfit") {
    return getLiveMetrics(row.trade.ticket)?.profit ?? 0;
  }
  if (column === "priceChange") {
    return getLiveMetrics(row.trade.ticket)?.priceChange ?? 0;
  }
  if (column === "liveCurrentPrice") {
    return getLiveMetrics(row.trade.ticket)?.currentPrice ?? 0;
  }
  const value = row.trade[column as keyof typeof row.trade];
  if (typeof value === "number") return value;
  return String(value ?? "").toLowerCase();
}

export function getRowFilterHaystack(
  row: OpenPositionTableRowData,
  column: string
): string {
  if (column === "tradeType") return row.tradeType.toLowerCase();
  if (LIVE_TABLE_COLUMNS.has(column)) {
    const m = getLiveMetrics(row.trade.ticket);
    if (!m) return "";
    if (column === "liveProfit") return String(m.profit);
    if (column === "priceChange") return String(m.priceChange);
    if (column === "liveCurrentPrice") return String(m.currentPrice);
  }
  return String(
    row.trade[column as keyof typeof row.trade] ?? ""
  ).toLowerCase();
}
